import { createSession } from '@/services/session';
import { isHttpError } from '@/utils/errors';

/**
 * Returns UTM params stored in the Django session.  Accepts an optional flag to
 * immediately delete the params from storage once retrieved.
 *
 * Note: UTM params can technically be anything the user defines on their ad,
 * but are prefixed with utm_. Generally we will get a utm_source, but we can't
 * guarantee it.  Therefore we will only type the endpoint to potentially expect
 * this value, but the BE is already ensuring this endpoint only returns an object
 * with keys prefixed with utm_.
 */
export async function getUtmParams({ clearAfterRetrieve }: { clearAfterRetrieve?: boolean } = {}) {
  try {
    return await createSession('', { shouldTransform: false })
      .get<{ utm_source?: string }>(`/utm?clear=${Boolean(clearAfterRetrieve)}`)
      .then((utmParams) => utmParams.data);
  } catch (error) {
    if (!isHttpError(error)) {
      throw error;
    }
  }
}
